import React, {useContext} from 'react'
import {FormattedMessage} from 'react-intl'
import {Link, Redirect} from 'react-router-dom'
import AngleRight from '../../assets/icons/AngleRight.svg'
import {isBrowser} from '../../helpers/coreUtil'
import {RouterContext} from '../containers/Context'
import {useLocale} from '../hocs/hooks'
import styles from './NotFound.scss'

const NotFound = (props: {staticContext?: {status?: number}}) => {
  const locale = useLocale()
  const {location: {pathname}} = useContext(RouterContext)
  const ampRegex = /\/amp\/?$/
  if (pathname && ampRegex.test(pathname)) return <Redirect to={pathname.replace(ampRegex, '')}/>
  if (!isBrowser && props.staticContext) props.staticContext.status = 404
  return <div className="my-4 pb-5">
    <h2 className={['text-center font-weight-medium'].join(' ')}>404 error</h2>
    <div className={['text-primary text-center mb-5 mb-md-0 font-weight-bold', styles.main].join(' ')}>404</div>
    <div className={['mb-5 pb-4 mx-md-5 px-md-4', styles.explain].join(' ')}>
      <h1 className="mb-4 pb-3 font-weight-normal">
        <FormattedMessage id="app.404explain" defaultMessage="The page you requested could not be found."/>
      </h1>
      <h5 className="font-weight-normal">
        <FormattedMessage id="app.404reason" defaultMessage="The page you tried to access may have been deleted or moved to another location."/>
      </h5>
    </div>
    <div className="text-center">
      <Link to={`/${locale}/`} className="btn btn-primary pl-5">
        <div className="d-flex">
          <h5 className="mr-5 mb-0 py-1 font-weight-normal line-height-normal">
            <FormattedMessage id="app.404back" defaultMessage="Back to Top" />
          </h5>
          <AngleRight className="fa mr-2 font-size-50"/>
        </div>
      </Link>
    </div>
  </div>
}
NotFound.displayName = 'NotFound'
export default NotFound
